import AddRuleContainer from "./AddRuleContainer";

export default AddRuleContainer;
